<template>
  <ul
    v-if="categoriesWithFaqs.length > 0"
    class="faqs__groups-list"
  >
    <li
      v-for="category in categoriesWithFaqs"
      :id="category.id"
      :key="`${category.id}-group`"
      class="faqs__group"
    >
      <h2 class="faqs__group-title h5">
        {{ category.title }}
      </h2>

      <ul class="faqs__list">
        <li
          v-for="faq in category.faqs"
          :key="faq.title"
          class="faqs__list-item"
          :class="{ 'faqs__list-item--active': faq.show }"
        >
          <h3
            class="faqs__list-item-title"
            @click="faq.show = !faq.show"
          >
            {{ faq.title }}
            <MinusCircle v-if="faq.show" />
            <PlusCircle v-else />
          </h3>
          <Vue3SlideUpDown
            v-model="faq.show"
            :duration="300"
            class="faqs__list-item-text rte"
            v-html="faq.answer"
          />
        </li>
      </ul>
    </li>
  </ul>
  <div
    v-else
    class="text-center rte"
  >
    <p>
      Sorry there are no FAQs matching your search criteria
    </p>
  </div>
</template>

<script>
import { useFaqsStore } from '../pinia/FaqsStore'
import { mapState } from 'pinia'

import { Vue3SlideUpDown } from "vue3-slide-up-down"

import PlusCircle from '../icons/plus-circle'
import MinusCircle from '../icons/minus-circle'


export default {
  components: {
    PlusCircle,
    MinusCircle,
    Vue3SlideUpDown,
  },
  computed: {
    ...mapState(useFaqsStore, [
      'categoriesWithFaqs'
    ]),
  }
}
</script>
